import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=804ccf7e&"
import script from "./attachments.vue?vue&type=script&lang=js&"
export * from "./attachments.vue?vue&type=script&lang=js&"
import style0 from "./attachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports